import { ErrorText } from "@/lib/mui/ErrorText";
import { toUserError } from "./toUserError";
import { getUserFriendlyError } from "./getUserFriendlyError";
import {
  InsufficientCreditsMessage,
  isInsufficientCreditsError,
} from "@/modules/billing/insufficient-credits/InsufficientCreditsMessage";

type ErrorDisplayProps = {
  error: unknown;
};

export const ErrorDisplay = ({ error }: ErrorDisplayProps) => {
  const e = toUserError(error);
  return (
    <>
      <ErrorText>
        {isInsufficientCreditsError(e) ? (
          <InsufficientCreditsMessage />
        ) : (
          getUserFriendlyError(e)
        )}

        {process.env.NODE_ENV === "development" && (
          <div>
            <pre style={{ fontSize: "0.8em" }}>
              {JSON.stringify(e, null, 2)}
            </pre>
          </div>
        )}
      </ErrorText>
    </>
  );
};
